import React, { Component } from 'react';
import queryString from 'query-string';
import Config from '../../Config';

class oauth extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    let qs = queryString.parse(this.props.location.search);
    if (!qs.access_token) {
      Config.curUser.lang = localStorage.getItem('dlink-user-lang')
        ? localStorage.getItem('dlink-user-lang')
        : 'en';
      this.props.history.push('/');

      return;
    }
    Config.curUser = qs;
    if (Config.curUser.api_site) {
      Config.baseUrl = 'https://' + Config.curUser.api_site + '/';
    }
    localStorage.setItem('dlinkuser', JSON.stringify(qs));
    this.props.history.push('/profile');
  }

  render() {
    return <div className="container text-center">Loading...</div>;
  }
}

export default oauth;



// WEBPACK FOOTER //
// ./src/components/common/oauth.js